var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 12C6.81843 12 7.52323 11.5655 7.83248 10.9453H4.16748C4.47673 11.5655 5.18156 12 5.99998 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1333 5.80927V5.03906C10.1333 3.40261 8.89571 2.0156 7.20001 1.56258V1.05469C7.20001 0.473133 6.66169 0 6.00001 0C5.33834 0 4.80002 0.473133 4.80002 1.05469V1.56258C3.10429 2.0156 1.86669 3.40259 1.86669 5.03906V5.80927C1.86669 7.24673 1.24328 8.60977 0.111311 9.6473C0.000377834 9.74897 -0.0307954 9.89899 0.0320844 10.0286C0.0949642 10.1581 0.239764 10.2422 0.40003 10.2422H11.6C11.7603 10.2422 11.905 10.1581 11.9679 10.0286C12.0308 9.89899 11.9996 9.74897 11.8887 9.6473C10.7567 8.60977 10.1333 7.24671 10.1333 5.80927ZM6.40001 1.42331C6.26836 1.41216 6.13495 1.40625 6.00001 1.40625C5.86508 1.40625 5.73167 1.41216 5.60001 1.42331V1.05469C5.60001 0.860836 5.77945 0.703125 6.00001 0.703125C6.22057 0.703125 6.40001 0.860836 6.40001 1.05469V1.42331Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 5.03906C11.2 5.23322 11.3791 5.39062 11.6 5.39062C11.8209 5.39062 12 5.23322 12 5.03906C12 3.63047 11.3759 2.30618 10.2427 1.31016C10.0865 1.17288 9.83319 1.17286 9.67697 1.31016C9.52076 1.44745 9.52076 1.67004 9.67697 1.80733C10.6591 2.67056 11.2 3.81827 11.2 5.03906Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399999 5.39062C0.620905 5.39062 0.799998 5.23322 0.799998 5.03906C0.799998 3.8183 1.3409 2.67059 2.32303 1.80736C2.47925 1.67006 2.47925 1.44748 2.32303 1.31018C2.16685 1.17288 1.91357 1.17288 1.75735 1.31018C0.624105 2.3062 0 3.63047 0 5.03906C0 5.23322 0.179093 5.39062 0.399999 5.39062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.def860e0c0851848b2bc89b987362713.svg";
export { ForwardRef as ReactComponent };